import * as React from 'react';
import Input from '@material-ui/core/Input';

const CustomInput = (props) => {
    return <Input {...props} />;
};

export { CustomInput as Input };
